import * as React from "react";
import { forwardRef } from "react";
const SvgLogOut = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13.5 6L16.5 9M16.5 9L13.5 12M16.5 9H6.75M11.25 3.15303C10.2939 2.57871 9.18393 2.25 8 2.25C4.41015 2.25 1.5 5.27208 1.5 9C1.5 12.7279 4.41015 15.75 8 15.75C9.18393 15.75 10.2939 15.4213 11.25 14.847", stroke: "#222222", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgLogOut);
export default ForwardRef;
